<template>
    <d2-container type="card" :filename="filename">
        <el-row :gutter="20" v-loading="loading">
            <el-col :span="14">
                <el-form ref="form" :model="form" label-width="80px">
                    <el-form-item label="头像">
                        <el-upload
                                class="avatar-uploader"
                                action="api/updateUserImg.do"
                                :headers="{'X-Token':token}"
                                :limit="1"
                                :show-file-list="false"
                                :on-success="handleAvatarSuccess"
                                :before-upload="beforeAvatarUpload"
                                :on-preview="handlePreview"
                                :on-progress="uploadOnProgress">
                            <el-progress v-if="circle" type="circle" :percentage="percentage"></el-progress>
                            <img v-if="form.imgurl" :src="'//cdn.heanny.cn/HeadPortrait/'+form.imgurl" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="账户">
                        <el-input v-model="user" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="昵称">
                        <el-input v-model="form.name" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="性别">
                        <el-select v-model="form.sex" placeholder="请选择性别">
                            <el-option label="男" value="男"></el-option>
                            <el-option label="女" value="女"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="权限">
                        <el-select v-model="form.role" placeholder="请选择权限">
                            <el-option label="用户" value="0"></el-option>
                            <el-option label="管理员" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="职业">
                        <el-input v-model="form.position" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="介绍">
                        <el-input
                                type="textarea"
                                :autosize="{ minRows: 2, maxRows: 4}"
                                placeholder="请输入内容"
                                v-model="form.text">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="电话">
                        <el-input v-model="form.tel" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱">
                        <el-input v-model="form.mail" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit" :loading="SubLoading">修改资料</el-button>
                        <el-button>取消</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
    </d2-container>
</template>

<script>
    import util from '@/libs/util.js'

    export default {
        data() {
            return {
                SubLoading: false,
                loading: false,
                filename: __filename,
                text: '<p>Hello World</p>',
                user: util.cookies.get('uuid'),
                status: '',
                percentage: 0,
                circle: false,
                token: util.cookies.get('token'),
                form: {
                    name: '',
                    imgurl: '',
                    region: '',
                    date1: '',
                    date2: '',
                    delivery: false,
                    type: [],
                    resource: '',
                    position: '',
                    text: '',
                    desc: ''
                }

            }
        },
        methods: {
            BindWeibo() {
                this.$message({
                    message: '绑定成功',
                    type: 'success'
                });
            },
            uploadOnProgress(e, file, fileList) {//开始上传
                this.percentage = Math.floor(e.percent)
            },
            handleAvatarSuccess(row) {
                if (row.code === 0) {
                    this.$message({
                        message: '上传成功',
                        type: 'success'
                    });
                    this.form.imgurl = row.data
                    this.circle = false;
                } else {
                    this.$message.error('上传失败，请重试');
                }
            },
            beforeAvatarUpload(row) {
                this.circle = true;
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log('handlePreview', file);
            },
            onSubmit() {
                this.SubLoading = true
                this.form.user = this.user
                this.$request({url: 'updateUserByUser.do', data: this.form}).then(res => {
                    this.SubLoading = false
                    this.$message({
                        message: '修改成功',
                        type: 'success'
                    });
                    this.getData()
                }).catch(err => {
                    this.SubLoading = false
                    this.$message.error('修改失败，请重试');
                })
            },
            getData() {
                this.loading = true
                const _this = this
                this.$request({
                    url: 'getUserByUser.do',  data: {
                        username: this.user,
                    }
                }).then(res => {
                    _this.form = res
                    _this.loading = false
                }).catch((error) => {
                    this.msg = error
                    _this.loading = false
                })
            },
            UpdateImg(row) {
                //暂停使用
                const _this = this
                this.circle = true
                console.log(row.file)
                this.$request({
                    url: row.action, method: 'post', data: {
                        action: 'changeImg',
                        file: row.file
                    },
                }).then(res => {
                    _this.circle = false
                }).catch((error) => {
                    _this.circle = false
                })
            },
        },
        created: function () {

            this.getData()
        },
        mounted() {
            // this.$nextTick(function () {
            //     this.circle = true
            //     const _this = this
            //     setInterval(function () {
            //         if (_this.percentage < 100) {
            //             _this.percentage += 1
            //         }
            //     }, 100)
            //
            // });

        }
    }
</script>

<style scoped>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    /*
    进度条
     */
    .el-progress {
        background-color: #d4d4d4a6;
        /*position: absolute;*/
        /*width: 178px;*/
        /*height: 178px;*/
        /*top: 0px;*/
        /*left: 0px;*/
    }

    .avatar-uploader .el-progress {
        position: absolute;
        top: 0px;
        left: 0px;
        padding: 25.5px;
        /*padding-left: 25.5px;*/

    }

    .avatar-uploader .el-progress .el-progress-circle {

    }

    .bindA {
        margin: auto 10px;
    }
</style>
